import React, { PropTypes }  from 'react';

import icons from './icons.svg';
import './Icon.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func
};

const Icon = ({ id, isSelected, onClick }) => {
  return (
    <svg className={isSelected ? 'Icon Icon-selected' : 'Icon'} onClick={onClick}>
      <use xlinkHref={`${icons}#${id}`} />
    </svg>
  );
};

Icon.propTypes = propTypes;

export default Icon;



/** WEBPACK FOOTER **
 ** ./src/components/Icon.js
 **/